/**
 * Helpers leves para input monetário (R$) que respeitam o padrão V2:
 * valor armazenado em CENTAVOS (integer). Fina camada por cima do
 * CurrencyFormatter principal pra usar em componentes inline (drawers, etc.)
 * sem precisar trazer o ModernCurrencyInput completo.
 */

import CurrencyFormatter from './CurrencyFormatter';

/**
 * Centavos -> string "1.234,56" pra usar como `value` do input.
 */
export const centsToDisplay = (cents) => {
  const c = Number.isFinite(cents) ? cents : 0;
  if (!c) return '';
  return (c / 100).toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

/**
 * Trata onChange de input monetário: extrai só dígitos, retorna centavos.
 * Ex.: usuário digita "30" -> 30 cents (R$ 0,30); "3000" -> 3000 cents (R$ 30,00).
 */
export const parseInputToCents = (rawText) => {
  const digits = String(rawText || '').replace(/\D/g, '');
  if (!digits) return 0;
  return parseInt(digits, 10);
};

/**
 * Compat: CurrencyFormatter.centsToFormatted devolve "R$ 30,00".
 * Re-export pra quem precisa.
 */
export const centsToBRL = (cents) => CurrencyFormatter.centsToFormatted(cents);

export default {
  centsToDisplay,
  parseInputToCents,
  centsToBRL,
};
